import React, { useEffect, useState } from 'react';
import { getAuthorizationBearer } from '../../api/endpoint';

export const HtmlViewer = ({ url, $zoomLevel, $loaded }: { url: string, $zoomLevel, $loaded }) => {
    const [htmlContent, setHtmlContent] = useState('');

    const clearHtml = (data: any) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(data, 'text/html');

        const elementToRemove = doc.getElementById('pfptBanner5n8cjd9');
        if (elementToRemove) {
            elementToRemove.remove();
        }

        const serializer = new XMLSerializer();
        const cleanedHtml = serializer.serializeToString(doc);

        return cleanedHtml;
    }

    useEffect(() => {
        const fetchHtmlContent = async () => {
            try {
                const response = await fetch(url, {
                    headers: {
                        'Authorization': getAuthorizationBearer(),
                    },
                });

                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }

                const data = await response.text();
                const cleanedData = clearHtml(data);
                setHtmlContent(cleanedData);
            } catch (error) {
                console.error('Error fetching HTML:', error);
            }
        };

        fetchHtmlContent();
        $loaded.set(true);
    }, []);

    return (
        <div
            style={{ transform: `scale(${$zoomLevel.value})`, transformOrigin: '0 0' }}
            dangerouslySetInnerHTML={{ __html: htmlContent }}
        />
    );
}

